export enum UserActionScopeType {
    New,
    Delete,
    Edit,
    Details,
    List,
    Dashboard,
    Frontpage,
    Owner,
    Logo,
    BasicData,
    ProjectData,
    ContactData,
    Description,
    Slug,
    Publication,
    Availability,
    Titles,
    Images,
    OtherLinks,
    SocialMediaLinks,
    BillingData,
    Logistics,
    PickupAddress,
    PickupDelivery,
    ShippingRate,
    ShippingRateService,
    PaymentOptions,
    PaymentAtLocation,
    PaymentOnDelivery,
    BankTransferPayment,
    PayPalPayment,
    RedsysPayment,
    PersonalBizumPayment,
    NameAndDescription,
    IsNonPhysical,
    CategoriesAndCharacteristics,
    Sku,
    Skus,
    Stock,
    Discounts,
    Resend,
    OpeningHours,
    OrderingHours,
    ReferencesClassification,
    BusinessReferenceCategories,
    BusinessReferenceCharacteristics,
    BusinessReferenceSkuAttributes,
    TimeSensitivity,
    CustomHighlights,
    ImageAndTitles,
    SellingStatus,
    HelpSite,
    ContactSettings,
    SkuSerialReceipt,
    SlugAvailability,
    CanonicalConsumer,
    Clone,
    BookingOptions,
    PlainPost,
    FlashOffer,
    Event,
    UpdatePost
}
